import React from 'react';
import { Button } from '@mui/material';

const CreateRestaurant = () => {
    function createResData() {
        // stage: change it to restaurants for production
        console.log('Nice! Creating... Comented code');
        // createCollection(connectionName, resortData);
        // console.log('Nice! Created...');
    }


  return (
    <div>
      <Button
          fullWidth
          onClick={() => createResData()}
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
      >
          Create Restaurant Data
      </Button>
    </div>
  );
}

export default CreateRestaurant;
